



















































import Vue from "vue"
import { Component } from "vue-property-decorator"
import CreateReminderViewModel from "@/models/reminders/createReminderViewModel"

@Component
export default class PageCreateReminderComponent extends Vue {
    languages: string[] = [];
    isLoading = false;
    vm: CreateReminderViewModel = new CreateReminderViewModel();
    get title(): string {
        return this.id ? "Редактирование напоминания" : "Добавление напоминания";
    }
    get id(): number {
        const routeId = this.$route.params.id;
        return routeId ? Number(routeId) : 0;
    }
    async created() {
        this.languages = await this.$cacheProvider.getLanguagesAsync();
        this.vm.initLanguages(this.languages);
        if (this.id) {
            await this.fetchData();
        }
    }
    async fetchData() {
      const res = await this.$api.ReminderService.getReminderAsync(this.id);
      this.vm.fromServerModel(res);
    }
    save() {
      const isValid = (this.$refs.validator as any).isValid();
      if (!isValid) {
        return;
      }
      this.isLoading = true;
      const req = this.vm.toServerModel();
      this.$api.ReminderService.updateAsync(req);
      this.isLoading = false;
      this.$notification.success('Оповещение успешно обновлено');
      this.$router.back();
    }
}
